/* Selecteur d'aide au choix : une question a la fois. Chaque resultat porte ses combinaisons (data-answers,
   separees par "|", une lettre par question, * = n'importe quelle reponse, ex. "A,B|*,A,*,*").
   Une reponse qui ne mene a aucun resultat n'est pas proposee, une question qui n'a plus qu'une reponse possible
   est sautee, et les resultats s'affichent des que les questions restantes valent * pour tous ceux encore possibles. */
if (!customElements.get('pp-selecteur')) {
  class PpSelecteur extends HTMLElement {
    connectedCallback() {
      this.questions = [...this.querySelectorAll('[data-q]')];
      this.results = [...this.querySelectorAll('[data-answers]')];
      this.results.forEach((r) => { r.combos = r.dataset.answers.split('|').map((c) => c.split(',')); });
      this.reset = this.querySelector('[data-reset]');
      this.answers = [];
      this.asked = 1;
      this.addEventListener('change', (e) => {
        const q = e.target.closest('[data-q]');
        if (!q) return;
        const i = this.questions.indexOf(q);
        this.answers = this.answers.slice(0, i);
        this.answers[i] = e.target.value;
        q.hidden = true;
        this.reset.hidden = false;
        this.advance(i + 1);
      });
      this.reset.addEventListener('click', () => this.restart());
    }

    // La combinaison est-elle compatible avec les reponses des questions 0 a upto-1 ?
    fits(combo, upto) {
      for (let k = 0; k < upto; k += 1) {
        const c = combo[k] || '*';
        if (c !== '*' && c !== this.answers[k]) return false;
      }
      return true;
    }

    advance(j) {
      for (;;) {
        const candidates = this.results.filter((r) => r.combos.some((c) => this.fits(c, j)));
        const finished = candidates.every((r) => r.combos.some((c) => this.fits(c, j)
          && c.slice(j).every((v) => v === '*')));
        if (!candidates.length || j >= this.questions.length || finished) {
          this.show(candidates);
          return;
        }
        const q = this.questions[j];
        const inputs = [...q.querySelectorAll('input')];
        const possible = inputs.filter((input) => candidates.some((r) => r.combos.some((c) => this.fits(c, j)
          && ['*', input.value].includes(c[j] || '*'))));
        inputs.forEach((input) => { input.closest('label').hidden = !possible.includes(input); });
        if (possible.length === 1) {
          possible[0].checked = true;
          this.answers[j] = possible[0].value;
          j += 1;
        } else if (!possible.length) {
          this.show([]);
          return;
        } else {
          this.asked += 1;
          const step = q.querySelector('.pso-sel__step');
          if (step) step.textContent = step.textContent.replace(/^Question \d+/, `Question ${this.asked}`);
          q.hidden = false;
          q.focus();
          return;
        }
      }
    }

    show(matches) {
      const head = this.querySelector('[data-result-head]');
      const fallback = this.querySelector('[data-fallback]');
      (matches.length ? matches : [fallback]).forEach((r) => { if (r) r.hidden = false; });
      if (head && matches.length) {
        head.textContent = matches.length > 1
          ? `${matches.length} modèles correspondent à vos réponses`
          : 'Le modèle qui correspond le mieux à vos besoins';
        head.hidden = false;
      }
      if (window.dataLayer) {
        window.dataLayer.push({
          event: 'selecteur_resultat',
          selecteur: this.dataset.name,
          resultat: matches.map((r) => r.querySelector('h3').textContent.trim()).join(' | ') || 'aucun'
        });
      }
    }

    restart() {
      this.querySelectorAll('input:checked').forEach((input) => { input.checked = false; });
      this.querySelectorAll('.pso-sel__choice').forEach((label) => { label.hidden = false; });
      this.querySelectorAll('[data-answers], [data-fallback], [data-result-head]').forEach((r) => { r.hidden = true; });
      this.questions.forEach((q, i) => { q.hidden = i > 0; });
      this.answers = [];
      this.asked = 1;
      this.reset.hidden = true;
      this.questions[0].focus();
    }
  }
  customElements.define('pp-selecteur', PpSelecteur);
}

/* Onglets d'informations produit (motif ARIA tabs, fleches gauche/droite). */
if (!customElements.get('pp-onglets')) {
  class PpOnglets extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab));
        tab.addEventListener('keydown', (e) => {
          const step = { ArrowRight: 1, ArrowLeft: -1 }[e.key];
          if (!step) return;
          const target = this.tabs[(this.tabs.indexOf(tab) + step + this.tabs.length) % this.tabs.length];
          this.select(target);
          target.focus();
        });
      });
      this.select(this.tabs[0]);

      // Accordeon mobile : meme etat que les onglets, un clic sur la rubrique ouverte la referme
      this.querySelectorAll('.pso-acc').forEach((acc) => {
        acc.addEventListener('click', () => {
          if (acc.getAttribute('aria-expanded') === 'true') {
            acc.setAttribute('aria-expanded', 'false');
            acc.nextElementSibling.hidden = true;
            return;
          }
          this.select(document.getElementById(acc.dataset.for));
        });
      });

      // Les etoiles Avis Garantis du haut de fiche pointent vers #ag-s : ouvrir l'onglet Avis avant le saut
      const avis = this.querySelector('[data-tab-avis]');
      document.addEventListener('click', (e) => {
        if (e.target.closest('a[href="#ag-s"]')) this.select(avis);
      }, true);
    }

    select(active) {
      this.tabs.forEach((tab) => {
        const on = tab === active;
        tab.setAttribute('aria-selected', on);
        tab.tabIndex = on ? 0 : -1;
        document.getElementById(tab.getAttribute('aria-controls')).hidden = !on;
        this.querySelector(`[data-for="${tab.id}"]`).setAttribute('aria-expanded', on);
      });
    }
  }
  customElements.define('pp-onglets', PpOnglets);
}
